import { Navigate, useLocation, useParams } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useOperator, useOperatorAccess } from "@/hooks";
import { usePermissions } from "@/permissions";
import { EPermission } from "@/permissions/types";
import { useAppSelector } from "@/redux/hooks";
import { selectIsOnboardingComplete } from "@/redux/slices/quickSetup";

export const Home = () => {
  const operator = useOperator();
  const { operatorId } = useParams();
  const { hasPermission } = usePermissions();
  const location = useLocation();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const { isAdmin, isUnsubscribed, isSolo, isLoading: isLoadingAccess } = useOperatorAccess();

  const currentOperatorId = operatorId || operator.id;
  const isAlreadyInOperatorPath = location.pathname.includes(`/operator/${currentOperatorId}`);

  if (!isAdmin) {
    const path = isAlreadyInOperatorPath ? "bookings" : `operator/${currentOperatorId}/bookings`;
    return <Navigate to={path} />;
  }

  // Wait for subscription state before deciding where to land an admin.
  if (isOnboardingComplete === null || isLoadingAccess) {
    return <Loading />;
  }

  let destination: string;
  if (isUnsubscribed) {
    // Inactive account → lock pane (banner + reduced menu handled by layout).
    destination = "subscription-required";
  } else if (isSolo) {
    // Solo operators manage day-to-day in the Driver App; their web home is Get Started.
    destination = "get-started";
  } else if (isOnboardingComplete) {
    destination = "bookings";
  } else {
    const canViewGetStarted = hasPermission(EPermission.ProviderGetStartedManage);
    destination = canViewGetStarted ? "get-started" : "quick-setup";
  }
  const path = isAlreadyInOperatorPath ? destination : `operator/${currentOperatorId}/${destination}`;

  return <Navigate to={path} />;
};
